/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Shipping_Carrier_Delete_ErrorInputs */

const vi_toast_shipping_carrier_delete_error = /** @type {(inputs: Toast_Shipping_Carrier_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa đơn vị vận chuyển thất bại`)
};

/**

* @param {Toast_Shipping_Carrier_Delete_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_shipping_carrier_delete_error = /** @type {((inputs?: Toast_Shipping_Carrier_Delete_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Shipping_Carrier_Delete_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_shipping_carrier_delete_error(inputs)
});